/**
 * Espera a que el contenedor nativo (Cordova) y el UUID del dispositivo estén listos.
 * Evita la primera llamada a APIs de token con idDevice vacío o bridge aún no inicializado.
 */

function hasValidNativeDeviceUuid() {
    try {
        const uuid = window.app && typeof window.app.getDeviceUUID === "function" && window.app.getDeviceUUID();
        return !!(uuid && String(uuid).trim());
    } catch (e) {
        return false;
    }
}

/**
 * @param {number} timeoutMs tiempo máximo de espera del UUID tras intentar deviceready
 * @returns {Promise<boolean>} true si listo o no aplica Cordova; false si vence el tiempo sin UUID
 */
// eslint-disable-next-line import/prefer-default-export
export async function waitForNativeBootstrapReady(timeoutMs = 10000) {
    if (!window.cordova) {
        return true;
    }

    if (hasValidNativeDeviceUuid()) {
        return true;
    }

    await Promise.race([
        new Promise((resolve) => {
            document.addEventListener("deviceready", resolve, { once: true });
        }),
        new Promise((resolve) => {
            setTimeout(resolve, 5000);
        }),
    ]);

    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
        if (hasValidNativeDeviceUuid()) {
            return true;
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, 50));
    }

    return false;
}
